import { RouterView } from 'vue-router';

export const degreeRoutes = {
  path: 'degree/:id',
  component: () => import('layouts/DegreeLayout.vue'),
  children: [
    {
      name: 'showDegree',
      path: '',
      redirect: { name: 'showDegreeGradeSubmitted' },
    },
    {
      path: 'thesis',
      name: 'showDegreeThesis',
      redirect: { name: 'showDegreeThesisDashboard' },
      component: () => import('pages/degree/thesis/ThesisLayout.vue'),
      children: [
        {
          path: 'dashboard',
          name: 'showDegreeThesisDashboard',
          component: () => import('pages/degree/thesis/DashboardPage.vue'),
        },
        {
          path: 'list',
          name: 'showDegreeThesisListRoot',
          component: RouterView,
          children: [
            {
              path: '',
              name: 'showDegreeThesisList',
              component: () => import('pages/degree/thesis/ListPage.vue'),
            },
            {
              path: ':thesisId',
              name: 'showDegreeThesisShow',
              component: () => import('pages/degree/thesis/ShowPage.vue'),
            },
          ],
        },
        {
          path: 'reviewer',
          name: 'showDegreeThesisReviewerList',
          component: () => import('pages/degree/thesis/ReviewerListPage.vue'),
        },
        {
          path: 'area_professor',
          name: 'showDegreeThesisAreaProfessorList',
          component: () => import('pages/degree/thesis/AreaProfessorListPage.vue'),
        },
        // {
        //   path: 'external_users',
        //   name: 'showExternalSupervisorListRoot',
        //   component: RouterView,
        //   children: [
        //     {
        //       path: '',
        //       name: 'showExternalUserList',
        //       component: () =>
        //         import('pages/degree/thesis/ListExternalUserPage.vue'),
        //     },
        //     {
        //       path: ':externalSupervisorId',
        //       name: 'showExternalUserShow',
        //       component: () =>
        //         import('pages/degree/thesis/ShowExternalUserPage.vue'),
        //     },
        //   ],
        // },
      ],
    },
    {
      name: 'showDegreeGradeSubmitted',
      path: 'grade_submitted',
      redirect: { name: 'showDegreeGradeSubmittedList' },
      component: RouterView,
      children: [
        {
          path: 'courses',
          name: 'showDegreeGradeSubmittedList',
          redirect: { name: 'showDegreeGradeSubmittedModules' },
          component: () => import('pages/degree/GradeSubmittedNav.vue'),
          children: [
            {
              name: 'showDegreeGradeSubmittedModules',
              path: 'modules',
              component: () => import('pages/degree/GradeSubmittedModules.vue'),
            },
          ],
        },

        // {
        //   path: 'tutorial',
        //   name: 'showDegreeGradeSubmittedTutorial',
        //   component: () => import('pages/degree/GradeSubmittedTutorial.vue'),
        // },
        // {
        //   path: 'amendments',
        //   name: 'showDegreeGradeSubmittedAmendments',
        //   component: () => import('pages/degree/GradeSubmittedAmendments.vue'),
        // },
        {
          path: 'show/:courseInstanceId',
          name: 'showDegreeGradeSubmittedShow',
          component: () => import('pages/degree/GradeSubmittedCourseShow.vue'),
        },
      ],
    },
  ],
};
